import type { ReactNode } from 'react';

/**
 * Sigillo Famecert del footer della sidebar, introdotto dal v40 (riga 4441).
 * Porting verbatim dell'SVG del riferimento: geometrie, colori e testi sono i
 * suoi. L'altezza (150px) arriva da `.sb-seal svg` in `fametrue.css`.
 *
 * I testi restano letterali e non passano dai file di localizzazione: sono la
 * riproduzione grafica di un sigillo, non stringhe di interfaccia. Il codice
 * `FC26-X-00` è il segnaposto del riferimento.
 *
 * Da non confondere con `dashboard/FamecertBadge`, che è il badge di stato
 * accanto al nome del brand: stesso sigillo in miniatura, senza i testi e con
 * l'esagono della spunta al posto loro.
 */
export function FamecertSeal(): ReactNode {
  return (
    <div className="sb-seal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 180 204"
        role="img"
        aria-label="Sigillo FameCert, Certified, FC26-X-00, fametrue.com"
      >
        <path
          d="M105.59,16.00 L158.42,46.50 C166.04,50.90 172.27,61.70 172.27,70.50 L172.27,133.50 C172.27,142.30 166.04,153.10 158.42,157.50 L105.59,188.00 C97.01,192.95 82.99,192.95 74.41,188.00 L21.58,157.50 C13.96,153.10 7.73,142.30 7.73,133.50 L7.73,70.50 C7.73,61.70 13.96,50.90 21.58,46.50 L74.41,16.00 C82.99,11.05 97.01,11.05 105.59,16.00 Z"
          fill="#DF6616"
        />
        <path
          d="M104.84,20.12 L155.14,49.16 C162.40,53.35 168.33,63.63 168.33,72.01 L168.33,131.99 C168.33,140.37 162.40,150.65 155.14,154.84 L104.84,183.88 C96.68,188.59 83.32,188.59 75.16,183.88 L24.86,154.84 C17.60,150.65 11.67,140.37 11.67,131.99 L11.67,72.01 C11.67,63.63 17.60,53.35 24.86,49.16 L75.16,20.12 C83.32,15.41 96.68,15.41 104.84,20.12 Z"
          fill="#0A1B38"
        />
        <text
          x="90"
          y="62"
          textAnchor="middle"
          fontFamily="var(--font-mono)"
          fontSize="8.5"
          fontWeight="500"
          fill="#FFFFFF"
          opacity="0.85"
          letterSpacing="1.6"
        >
          FC26-X-00
        </text>
        <text
          x="90"
          y="99"
          textAnchor="middle"
          fontFamily="var(--font-display)"
          fontSize="33"
          fontWeight="500"
          letterSpacing="-0.5"
        >
          <tspan fill="#FFFFFF">Fame</tspan>
          <tspan fill="#5BCBBC">Cert</tspan>
        </text>
        <text
          x="90"
          y="117"
          textAnchor="middle"
          fontFamily="var(--font-sans)"
          fontSize="9.2"
          fontWeight="600"
          fill="#FFFFFF"
          letterSpacing="2.1"
        >
          CERTIFIED
        </text>
        <text
          x="90"
          y="128"
          textAnchor="middle"
          fontFamily="var(--font-sans)"
          fontSize="9.2"
          fontWeight="600"
          fill="#FFFFFF"
          letterSpacing="2.1"
        >
          REVIEW PROCESS
        </text>
        <polygon
          points="74,139 106,139 115,152 106,165 74,165 65,152"
          fill="#5BCBBC"
          stroke="#5BCBBC"
          strokeWidth="4.3"
          strokeLinejoin="round"
        />
        <path
          d="M82,152 L87,158 L98,145"
          fill="none"
          stroke="#0A1B38"
          strokeWidth="4.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
